/**
 * 服务管理状态配置 Hook
 * 提供服务管理相关的状态类型和默认值
 */

// 页面状态接口
export interface ServiceManagementState {
  searchParams: Record<string, any>;
  pagination: {
    current: number;
    pageSize: number;
  };
  createModalVisible: boolean;
  editModalVisible: boolean;
  tokenModalVisible: boolean;
  permissionViewVisible: boolean;
  currentRecord: any | null;
  serviceStats: {
    total_services: number;
    running_services: number;
    stopped_services: number;
    maintenance_services: number;
  };
}

// 默认状态配置
export const DEFAULT_SERVICE_STATE: ServiceManagementState = {
  searchParams: {},
  pagination: {
    current: 1,
    pageSize: 20, // 增加默认每页数量，确保能显示更多服务
  },
  createModalVisible: false,
  editModalVisible: false,
  tokenModalVisible: false,
  permissionViewVisible: false,
  currentRecord: null,
  serviceStats: {
    total_services: 0,
    running_services: 0,
    stopped_services: 0,
    maintenance_services: 0,
  },
};

